import React, { useState, useEffect } from 'react';
import Dashboard from './Dashboard';
import BruteForceTools from './BruteForceTools';
import SwatSystem from './SwatSystem';
import ATMVaultSystem from './ATMVaultSystem';
import Community from './Community';
import CompoundDefense from './CompoundDefense';
import './System.css';

const System = () => {
  const [activeTab, setActiveTab] = useState('dashboard');

  // Check URL parameters for direct tab navigation
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const tab = urlParams.get('tab');
    if (tab && ['dashboard', 'tools', 'swat', 'vaults', 'tasks', 'compound'].includes(tab)) {
      setActiveTab(tab);
    }
  }, []);

  const renderActiveTab = () => {
    switch (activeTab) {
      case 'dashboard':
        return <Dashboard />;
      case 'tools':
        return <BruteForceTools />;
      case 'swat':
        return <SwatSystem />;
      case 'vaults':
        return <ATMVaultSystem />;
      case 'tasks':
        return <Community />;
      case 'compound':
        return <CompoundDefense />;
      default:
        return <Dashboard />;
    }
  };

  return (
    <div className="container">
      <div className="content-section">
        <div className="content-section-header">
          <h2>🖥️ System Control Panel</h2>
          <p>Access your dashboard and hacking tools from this centralized interface.</p>
        </div>

        {/* Tab Navigation */}
        <div className="system-nav spacing-bottom-lg">
          <button 
            className={`system-tab ${activeTab === 'dashboard' ? 'active' : ''}`}
            onClick={() => setActiveTab('dashboard')}
          >
            📊 Dashboard
          </button>
          <button 
            className={`system-tab ${activeTab === 'tools' ? 'active' : ''}`}
            onClick={() => setActiveTab('tools')}
          >
            🔧 Tools
          </button>
          <button 
            className={`system-tab ${activeTab === 'swat' ? 'active' : ''}`}
            onClick={() => setActiveTab('swat')}
          >
            🚔 SWAT System
          </button>
          <button 
            className={`system-tab ${activeTab === 'vaults' ? 'active' : ''}`}
            onClick={() => setActiveTab('vaults')}
          >
            🔐 ATM Vaults
          </button>
          <button 
            className={`system-tab ${activeTab === 'tasks' ? 'active' : ''}`}
            onClick={() => setActiveTab('tasks')}
          >
            📋 My Tasks
          </button>
          <button 
            className={`system-tab ${activeTab === 'compound' ? 'active' : ''}`}
            onClick={() => setActiveTab('compound')}
          >
            🚐 Compound Defense
          </button>
        </div>

        {/* Tab Content */}
        <div className="system-content fade-in">
          {renderActiveTab()}
        </div>
      </div>
    </div>
  );
};

export default System;